import PrescriptionFulfillments from "../components/PrescriptionFulfillment"
function prescriptionFulfillment() {
    return (
        <PrescriptionFulfillments />
    )
}
export default prescriptionFulfillment